import $ from 'jquery';
import Isotope from 'isotope-layout';
//import imgLoad from '../modules/images.js';
//import lazyImagesLoaded from '../modules/lazyImagesLoaded';

export default {
  selectors: {
    dropdown:    '[data-faux-select]',
    placeholder: '[data-faux-select-placeholder]',
    checkbox:    '[data-faux-select-checkbox]',
    emptyNotice: '[data-empty-list-notice]',
  },
  isotopeGrid: null,

  _bindEvents() {

    /*
    lazyImagesLoaded('.product-list', null, this.initLayout.bind(this));

    imgLoad.on('always', () => {
      this.initLayout();
    });
    */

    // Open and close the dropdown
    $(this.selectors.dropdown).on('click', e => {
      if ( !$(e.target).closest('.c-faux-select__dropdown').length ) {
        this.toggleDropdown();
      }
    });

    // Close dropdown by clicking anywhere else
    $(document).on('click', e => {
      if ( !$(e.target).closest(this.selectors.dropdown).length ) {
        this.closeDropdown();
      }
    });

    // Apply and remove filters when filter options are clicked
    const checkboxes = document.querySelectorAll(this.selectors.checkbox);
    [].forEach.call(checkboxes, cb => {
      cb.addEventListener('change', e => {
        this.applyFilters();
      }, false);
    });
  },

  initLayout() {
    // HACK init isotope grid after timeout
    // without delayed init, product rows overlap eachother because of lazy loaded images
    // added padding to fix this, but FF doesn't listen
    // interestingly, always loads correctly on hard refresh, but not on soft
    // no time to investigate, possibly something to do with how FF cahces?
    setTimeout( () => {
      this.isotopeGrid = new Isotope('[data-isotope-grid]', {
        itemSelector: '.product-list__cell',
        layoutMode: 'vertical'
      });
    }, 1000);
  },

  init() {
    if ( !$(this.selectors.dropdown).html() ) return;
    this.initLayout();
    this._bindEvents();
  },

  toggleDropdown() {
    $(this.selectors.dropdown).toggleClass('open');
  },

  closeDropdown() {
    $(this.selectors.dropdown).removeClass('open');
  },

  /**
   * Applies filters to isotope layout
   */
  applyFilters() {
    const $checked = $(`${this.selectors.checkbox}:checked`);
    const filtersToApply = $checked.map( (i,el) => `[data-${el.value}]` ).get();
    const filterCount = filtersToApply.length;
    const filterValue = filterCount ? filtersToApply.join('') : '*';

    this.isotopeGrid.arrange({ filter: filterValue });

    this.updatePlaceholder(filterCount);
    this.toggleEmptyNotice(this.isotopeGrid.filteredItems.length);
  },

  updatePlaceholder(filterCount) {
    let label = filterCount > 0 ? `filters (${filterCount})` : 'filter by';
    $(this.selectors.placeholder).text(label);
  },

  /**
   * Checks if there are filterd items and
   * shows/hides "None Found" notice
   */
  toggleEmptyNotice(resultCount) {
    $(this.selectors.emptyNotice).toggle(resultCount < 1);
  },
}
